import each from 'lodash/each'
import { getNodeText } from './node'
import direction from 'constants/direction'

type UserRef = {
  id?: string
}

type EdgeEntity = {
  data?: {
    content?: string
    directionality?: string
    creator?: UserRef | string | null
    readers?: unknown[] | Record<string, unknown>
    writers?: unknown[] | Record<string, unknown>
  }
}

type NodeEntity = {
  data?: {
    content?: string
  }
}

export const getEdgeText = (edge: EdgeEntity, to?: NodeEntity, frm?: NodeEntity) => {
  let content = edge?.data?.content
  if (!content) {
    content = ''
  }

  const fromArrow = [direction.REVERSE, direction.BIDIRECTIONAL].includes(edge.data?.directionality || '')
    ? '<'
    : ''
  const toArrow = [direction.DIRECTED, direction.BIDIRECTIONAL].includes(edge.data?.directionality || '')
    ? '>'
    : ''

  const fromContent = getNodeText(frm)
  const toContent = getNodeText(to)

  return `${fromContent}${fromArrow}--[${content}]--${toArrow}${toContent}`
}

export const getUsersForEdge = (edge?: EdgeEntity) => {
  const userIds: string[] = []
  const creator = edge?.data?.creator
  if (typeof creator === 'string') {
    userIds.push(creator)
  } else if (creator?.id) {
    userIds.push(creator.id)
  }

  each(edge?.data?.readers, (r: unknown) => {
    const reader = r as UserRef
    if (reader?.id) {
      userIds.push(reader.id)
    }
  })

  each(edge?.data?.writers, (w: unknown) => {
    const writer = w as UserRef
    if (writer?.id) {
      userIds.push(writer.id)
    }
  })

  return userIds
}
